import { call, put, takeLatest } from 'redux-saga/effects'

import {  dashboardLoaderAC } from '../system/systemActionCreators'

import {
    typePagination,
    typeRequestPagination,
    paginationMapper,
} from '../system/constants'

import { IdCashDesksStateDataItem, typeCashDesksFilters } from 'model/dashboardCashDesks/dCashDesksReducer';
import {
    dCashDesksSetDataAC,
    dCashDesksSetDataSagaAC,
    dCashDesksSetPaginationAC
} from 'model/dashboardCashDesks/dCashDesksActionCreators';
import {
    getCashDeskList
} from 'model/dashboardCashDesks/dCashDesksAPI';
import { errorGenerator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdCashDesksStateDataItem[] => {
    return tempResponseData.map((item: IdCashDesksStateDataItem) => {
        return (
            {
                checked: false,
                dateCreated: item.dateCreated,
                dateEdited: item.dateEdited,
                fiscalCardId: item.fiscalCardId,
                id: item.id,
                posHardwareModel: item.posHardwareModel,
                posHardwareSerialNumber: item.posHardwareSerialNumber,
                posNumber: item.posNumber,
                store: item.store ? item.store : null,
                blocked: item.blocked
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typeCashDesksFilters, paginationRequest: typeRequestPagination }) {

    let response = yield call(getCashDeskList, payload)

    if (response.status === 200) {

        const tempData: IdCashDesksStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dCashDesksSetPaginationAC(pagination))

        yield put(dCashDesksSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Set CashDesk list saga
export function* dCashDesksSetDataWorker(actionObject: { type: string, payload: { filters: typeCashDesksFilters, paginationRequest: typeRequestPagination } }) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dCashDesksSetDataWatcher() {
    yield takeLatest(dCashDesksSetDataSagaAC.type, dCashDesksSetDataWorker)
}
